import axios from 'axios';
import { Capacitor } from '@capacitor/core';

// 운영 서버 도메인(Nginx가 /api를 백엔드로 프록시해주는 곳). 도메인이 바뀌면 여기만 고치면 된다.
const PROD_HOST = 'gbamtc.ddns.net';

// 스마트폰 앱(Capacitor 네이티브)은 브라우저 주소창이 없으므로 항상 운영 서버 절대주소를 쓴다.
// 웹에서 운영 도메인으로 접속했을 땐 같은 출처의 /api로(Nginx 프록시), 그 외(로컬 개발,
// 같은 와이파이의 다른 기기 등)는 접속 주소 기준으로 8000번 백엔드에 직접 접속한다.
export const API_BASE = Capacitor.isNativePlatform()
  ? `https://${PROD_HOST}/api`
  : window.location.hostname === PROD_HOST
    ? '/api'
    : `http://${window.location.hostname}:8000/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
